import React from 'react';


function Contact() {
    return (
        <div>
            <h1>OC Local Handyman Contact Page</h1>
        </div>
    );
}

export default Contact;